@if (userService.hasLoggedInUserAccess({type: 'prices', customerId})) {
    @if (priceOverrideText) {
        <div class="is-size-6 is-white-space-nowrap price-override-text">{{ priceOverrideText }}</div>

    } @else {
        @if (pricingModel.price?.netPrice) {
            @if (pricingModel.offerPrice?.netPrice) {
                <div class="container-price is-white-space-nowrap-tablet ">
                    @if (pricingModel.offerPrice) {
                        <span class="price-instead is-size-7">statt
                                        <span class="is-line-through">{{ this.articleService.getPrice(pricingModel.price?.netPrice || 0, article.taxRate, customerPriceMode) }}</span> nur
                                    </span>
                    }
                    <span class="price offer is-size-5">
                                   {{ this.articleService.getPrice(pricingModel.offerPrice?.netPrice || 0, article.taxRate, customerPriceMode) }}
                                </span><br>
                    @if (configService.getArticleShowPricePerUnit()) {
                        <span class="price-unit">
                                        {{ this.articleService.getUnitPrice(article.quantity || 0, pricingModel.offerPrice?.netPrice || 0, article.taxRate || 0, customerPriceMode) }}
                            / {{ article.unitAddition }}<br>
                                    </span>
                    }
                    @if (basicPrice) {
                        <span class="is-size-7"><iw-shop-article-price-basic
                                [taxRate]="article.taxRate"
                                [netPrice]="pricingModel.offerPrice?.netPrice || 0"
                                [quantity]="article.quantity" [unit]="article.unit"
                                [unitOfMeasurement]="article.unitOfMeasurement ?? ''"></iw-shop-article-price-basic></span>
                    }
                </div>
            }
            @if (!pricingModel.offerPrice) {
                <div class="container-price is-white-space-nowrap-tablet ">
                    <span class="price is-size-5">{{ this.articleService.getPrice(pricingModel.price?.netPrice || 0, article.taxRate || 0, customerPriceMode) }} </span><br>
                    @if (configService.getArticleShowPricePerUnit()) {
                        <span class="price-unit">
                                        {{ this.articleService.getUnitPrice(article.quantity || 0, pricingModel.price?.netPrice || 0, article.taxRate || 0, customerPriceMode) }}
                            / {{ article.unitAddition }}<br>
                                    </span>
                    }

                    @if (basicPrice) {
                        <span class="is-size-7"><iw-shop-article-price-basic
                                [taxRate]="article.taxRate"
                                [netPrice]="pricingModel.price?.netPrice || 0"
                                [quantity]="article.quantity" [unit]="article.unit"
                                [unitOfMeasurement]="article.unitOfMeasurement ?? ''"></iw-shop-article-price-basic></span>
                    }
                </div>
            }
            @if (pricingModel.articleQuantityPrices.length > 0 && isQuantityDiscount(pricingModel.articleQuantityPrices[0].netPrice, pricingModel.price?.netPrice ?? 0)) {
                <hr class="m-0"/>
                <span class="is-size-7 mr-1">ab {{ pricingModel.articleQuantityPrices[0].fromArticleQuantity }}
                    St. </span>
                <span
                        class="price is-size-5">{{ this.articleService.getPrice(pricingModel.articleQuantityPrices[0].netPrice || 0, article.taxRate || 0, customerPriceMode) }}
                            </span><br>
                @if (basicPrice) {
                    <span class="is-size-7"><iw-shop-article-price-basic
                            [taxRate]="article.taxRate"
                            [netPrice]="pricingModel.articleQuantityPrices[0].netPrice"
                            [quantity]="article.quantity"
                            [unit]="article.unit"
                            [unitOfMeasurement]="article.unitOfMeasurement ?? ''"></iw-shop-article-price-basic></span>
                }

            }
        }
        @if (!pricingModel.price?.netPrice) {
            <div class="is-white-space-nowrap price  is-size-5">0,00 €</div>
        }
        @if (pricingModel.getQuantityPriceString().length > 0 && (pricingModel.cartQuantityPrices.length > 0 || pricingModel.articleQuantityPrices.length > 1)) {
            <div
                    class="mt-2">
                <iw-shop-article-price-quantity-discount-button
                        [article]="article"></iw-shop-article-price-quantity-discount-button>
            </div>
        }
    }
}




